module.exports = __webpack_public_path__ + "img/荆芥炭.aa9a6cc4.jpg";